import Axios from "axios";
import { REMOVE_SHIPMENT, GET_ERRORS } from "./types";
import { success, error } from "./modalsFunctios";
import { antdMessageError, antdMessageSuccess } from "../../helpers/Utils";

const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

export const getShipments = (type, page, pageCount, filter) => async (dispatch) => {
  try {
    dispatch(setShipmentLoading());
    const { data } = await Axios.get(
      `/api/v1/order_shipments/c/${type}.json?page=${page}&per_page=${pageCount}${filter}`
    )
    dispatch({
      type: "GET_SHIPMENTS",
      payload: data,
    });
    return 1
  } catch (err) {
    dispatch({
      type: GET_ERRORS,
      payload: err.response.data,
    })
    return 0
  }
};

export const removeShipmentBeforeCalled =
  (id, order_id, position) => (dispatch) => {
    Axios.delete(
      `/api/v1/orders/${order_id}/shipments/${id}?order_type=${position}`
    )
      .then((res) => {
        if (res.data.success) {
          if (position && !["FakeOrder", "Order"].includes(position)) {
            dispatch({
              type: REMOVE_SHIPMENT,
              payload: {
                position: position,
                id: id,
                order_rows: res.data.order_rows,
                shipment: res.data.shipment,
              },
            });
          } else if (position == "FakeOrder") {
            document.getElementById("fake_order_modal_refetcher")?.click();
          } else {
            dispatch({
              type: "REMOVE_SHIPMENT_ORDER",
              payload: {
                orderId: order_id,
                id: id,
                order_rows: res.data.order_rows,
                shipment: res.data.shipment,
              },
            });
          }
          success("shipment-s");
        }
      })
      .catch((err) => {
        console.log({ err });
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data,
        });
        error("shipment-e");
      });
  };

export const sendInsuranceEmailDPD = async () => {
  try {
    const { data } = await Axios.post("/api/v1/orders/send_insurance_email");
    if (data.success) {
      return antdMessageSuccess(data.message);
    }
    throw new Error("ERR");
  } catch (err) {
    antdMessageError();
    console.log("err");
  }
};

export const setShipmentLoading = () => {
  return {
    type: "LOADING_SHIPMENT",
  };
};
